<template>
  <v-app>
    <sidebar-menu
      :drawer="drawer"
      :userData="userData"
      :companySelected="companySelected"
      :handleClickSettings="handleClickSettings"
    />
    <v-app-bar app dark dense :color="navColor">
      <v-tooltip right color="green" v-if="!hideIcon">
        <template v-slot:activator="{ on, attrs }">
          <img
            @click="handleClickMenu"
            src="@/assets/logo-mini-white.png"
            class="d-flex"
            width="36"
            style="cursor: pointer"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>Menu Lateral</span>
      </v-tooltip>
      <!-- <v-app-bar-nav-icon
        v-if="!hideIcon"
        @click="handleClickMenu()"
      ></v-app-bar-nav-icon> -->
      <v-spacer></v-spacer>
      <!-- <img v-if="!hideIcon" @click="handleClickMenu()" src="@/assets/logo-mini.png" class="d-flex justify-center" width="40"/> -->
      <!-- <v-toolbar-title class=""> -->
      <!-- <img
        src="@/assets/logo-header.png"
        class="d-flex mb-2 mt-2"
        id="logo-click"
        width="400"
      /> -->
      <!-- </v-toolbar-title> -->
      <h2 v-if="mode !== 'production'">
        Ambiente de {{ mode === "development" ? "Desenvolvimento" : "Testes" }}
      </h2>
      <v-spacer></v-spacer>
      <v-btn icon @click="logout()" v-if="!hideIconLogout">
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <alert
          :visible="!!error"
          dark
          :type="type"
          :message="error"
          :clickClose="() => (error = '')"
        />
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import Alert from "@/components/Alert";
import SidebarMenu from "@/components/SidebarMenu";
import * as HTTP from "@/api/requests/base";
// import { URL } from "@/api/config";

export default {
  components: { Alert, SidebarMenu },
  data: () => ({
    drawer: true,
    hideIcon: false,
    hideIconLogout: false,
    loading_promotions: false,
    error: "",
    type: "",
    userData: {},
    companySelected: {},
    navColor: "black",
    mode: "production",
  }),
  watch: {
    $route() {},
  },
  created() {
    this.mode = process.env.NODE_ENV;
    if (this.mode !== "production") {
      if (this.mode === "development") {
        this.navColor = "green darken-3";
      } else {
        this.navColor = "red daken-3";
      }
    }

    document.title = "SISTEMA SERGIO'S";
    if (this.$route.path == "/" || this.$route.path == "/escolher-empresa") {
      this.drawer = false;
      this.hideIcon = true;
      if (this.$route.path === "/escolher-empresa") {
        this.hideIconLogout = false;
      } else {
        this.hideIconLogout = true;
      }
    } else {
      this.drawer = true;
      this.hideIcon = false;
      this.hideIconLogout = false;
      this.getSessionUserData();
    }
  },
  updated() {
    if (this.$route.path == "/" || this.$route.path == "/escolher-empresa") {
      this.drawer = false;
      this.hideIcon = true;
      if (this.$route.path === "/escolher-empresa") {
        this.hideIconLogout = false;
      } else {
        this.hideIconLogout = true;
      }
    } else {
      if (this.$route.path === "/dashboard") {
        this.drawer = true;
      }
      this.hideIcon = false;
      this.hideIconLogout = false;
      this.getSessionUserData();
    }
  },
  methods: {
    logout() {
      localStorage.removeItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
      this.userData = {};
      this.$router.push({ name: "Login" });
    },
    handleClickMenu() {
      this.drawer = !this.drawer;
    },
    getSessionUserData() {
      if (Object.keys(this.userData).length === 0) {
        let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
        if (session) {
          session = JSON.parse(session);
          if (session.user !== "") {
            this.userData = session.user;
          }
          if (session.company_selected !== "") {
            this.companySelected = session.company_selected;
          }
        }
      }
      if (
        this.companySelected !== undefined &&
        Object.keys(this.companySelected).length === 0
      ) {
        let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
        if (session) {
          session = JSON.parse(session);
          if (session.company_selected !== "") {
            this.companySelected = session.company_selected;
          }
        }
      }
    },
    handleClickSettings() {
      if (
        this.userData.type === "provider" ||
        this.userData.type === "franchise"
      ) {
        this.companySelected = {};
        this.$router.push({ name: "ChooseCompany" });
      }
    },
  },
};
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 0.9rem !important;
  height: 52px;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #232323;
}
</style>
